import Unarchive from '@mui/icons-material/Unarchive';
import { FixMe } from '@greenkub-fronts/shared/interface';

export function UnarchiveIcon(props: FixMe) {
  return <Unarchive {...props} />;
}

export default UnarchiveIcon;
